import * as React from 'react';
export var QuoteCarouselItem = function (_a) {
    var title = _a.title, name = _a.name, image = _a.image, quote = _a.quote;
    return (React.createElement("div", { className: "card member-card text-center no-select" },
        React.createElement("div", { className: "image" },
            React.createElement("img", { src: image, className: "client-image", alt: typeof name === 'string' ? name : 'Client' })),
        React.createElement("h5", null, name),
        React.createElement("div", { className: "role" },
            React.createElement("small", null, title)),
        React.createElement("blockquote", null, quote)));
};
//# sourceMappingURL=QuoteCarouselItem.js.map